import PredictResult from '@/trials/domain/objects/predictResult';

/**
 * 予測結果一覧を保持するクラス
 */
export default class PredictResults {
    /**
     * 生データ\
     * 最後に実行完了した推論の結果データ取得APIのレスポンスを想定しています。
     */
    private _rawdata: any[];

    /**
     * 行番号をキーにした予測結果一覧
     */
    private _rowObjects: { [key: number]: any };

    /**
     * コンストラクタ
     * @param data 生データ
     */
    constructor(data: any[]) {
        this._rawdata = data;

        this._rowObjects = this._rawDataToObject();
    }

    /**
     * getter 予測結果一覧取得
     */
    public get data(): any[] {
        return this._rawdata;
    }

    /**
     * 生データから行番号をキーにした予測結果一覧を生成
     */
    private _rawDataToObject(): { [key: number]: PredictResult } {
        const ret: { [key: number]: PredictResult } = {};

        for (let i = 1; i < this._rawdata.length; i++) {
            const row = this._rawdata[i];
            ret[i] = new PredictResult(row[0], row[1], row[2]);
        }

        return ret;
    }

    /**
     * 行番号をもとに予測結果を返します
     * @param index 行番号
     */
    public fetchByIndex(index: number): PredictResult | null {
        const row: PredictResult = this._rowObjects[index];
        if (!row) {
            return null;
        }

        return row;
    }
}
